import { Flex } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Groups"];

// const items = [
//   {
//     id: 1,
//     Groups: "Bolton",
//   },
//   {
//     id: 1,
//     Groups: "Bolton 3",
//   },
// ];

function ManageGroups() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  // const [selectedItem, setSelectedItem] = useState();
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();

  const onOpen = (data) => {
    navigate("/groupview", {
      state: {
        action: "groupview-edit",
        data: data?.item?.data,
      },
    });
  };

  const onNew = () => {
    navigate("/groupview", {
      state: {
        action: "groupview-add",
        data: {},
      },
    });
  };

  const getList = async (data) => {
    setIsLoading(true);
    api
      .getGroups({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getList", res);

        if (res?.status === 200) {
          if (data?.page) {
            setActivePage(data.page);
          }
          if (res?.data && res?.data[0]) {
            const l = res.data.map((item, index) => ({
              id: `groups-${index}`,
              groups: item?.groupname || "",
              data: item,
            }));

            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onSelectItm = (data) => {
    onOpen(data);
    // console.log("onSelectItm", data);
    // setSelectedItem(data);
    // if (data?.item?.data?.state) {
    //   utils.getCliamStatusDD({
    //     setClaimStatusDD,
    //     defaultVal: data?.item?.data?.state,
    //   });
    // }
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cd = async () => {
      await getList();
    };
    cd();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Groups"} isLoading={isLoading} />

      <Flex justifyContent="space-between" gap={"1rem"} mb="1rem">
        <Flex />
        {/* <DropDown/> */}
        {/* <InputComp
          type={"search"}
          onChange={onChangeSearchTxt}
          loading={searchLoading}
        /> */}
        <ButtonComp
          label="New"
          keyname="new"
          variant="outline"
          onClick={onNew}
        />
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default ManageGroups;
